import React from 'react';
import loaderData from '../animations/loader.json';
import Lottie from 'lottie-react';

export const LuiLoadingSpinner = () => {
  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        zIndex: 1000,
        margin: '-74px',
      }}
      data-testid="loading-spinner"
    >
      <Lottie
        animationData={loaderData}
        loop={true}
        autoPlay={true}
        rendererSettings={{
          preserveAspectRatio: 'xMidYMid slice',
        }}
        style={{ height: 148, width: 148 }}
      />
    </div>
  );
};

interface LuiMiniSpinnerProps {
  size: number;
  // To allow data-testid, onClick, etc
  divProps?: any;
}
export const LuiMiniSpinner = (props: LuiMiniSpinnerProps) => {
  return (
    <div {...props.divProps}>
      <Lottie
        animationData={loaderData}
        loop={true}
        autoPlay={true}
        rendererSettings={{
          preserveAspectRatio: 'xMidYMid slice',
        }}
        style={{ height: props.size, width: props.size }}
      />
    </div>
  );
};
